<template>
  <div class="companies">
    <router-view />
    <div class="content--header-col">
      <div class="tabs-wrapper">
        <span
          v-for="tab in tabs"
          :to="tab.url"
          class="tab"
          :class="{ active: tab.id == activeTab }"
          :key="tab.id"
          ref="tabs"
          @click="handleTabClick({ data: tab })"
        >
          {{ tab.label }}
        </span>
        <div class="indicator" v-if="loaded" :style="indicatorStyle"></div>
      </div>
    </div>
    <SearchBar @search="handleSearchCompany" />
    <div class="content--main" v-if="companies">
      <div class="row" v-if="companies.length == 0">
        <div class="col-6 length-0">
          <span>No results found.</span>
        </div>
      </div>
      <div class="row" v-if="companies && companies.length != 0">
        <div class="col-4 company--list-wrapper">
          <div class="company--list" v-scroll="onScroll">
            <div v-for="(company, i) in companies" :key="i">
              <Widget
                :widgets="company"
                @widgetClick="handleWidgetClick(i)"
                :class="i === activeIndex ? 'active' : ''"
              >
                <div v-if="company.image" class="widget--avatar">
                  <img :src="company.image" alt="user avatar" />
                </div>
                <div v-else class="widget--avatar">
                  <span>{{ company.name[0] }}</span>
                </div>
                <div class="widget--info">
                  <p class="mb-0">
                    {{ company.name }}
                  </p>
                  <p class="muted mb-0">
                    {{ company.Users.length }} -
                    {{ company.Users.length > 1 ? "members" : "member" }}
                  </p>
                </div>
              </Widget>
            </div>
          </div>
        </div>
        <div class="col-8 company--profile-wrapper" v-if="singlecompany">
          <div class="company--profile">
            <WidgetDetails
              :title="singlecompany.companyType"
              @deleteCompany="handleDeleteCompanyClick"
              @editCompanyDetails="handleEditCompanyClick"
              :widgetOptions="widgetOptions"
            >
              <div class="d-flex">
                <div v-if="singlecompany.image" class="widget--avatar">
                  <img :src="singlecompany.image" alt="user avatar" />
                </div>
                <div v-else class="widget--avatar">
                  <span>{{ singlecompany.name[0] }}</span>
                </div>
                <div class="widget--details-wrapper">
                  <h4>
                    {{ singlecompany.name }}
                  </h4>
                  <p class="-muted" v-if="singlecompany.industry">
                    <img
                      src="~@/assets/media/icons/user.svg"
                      alt="company icon"
                      height="20"
                      width="20"
                    />{{ singlecompany.industry }} Company
                  </p>
                  <div class="row">
                    <div class="col">
                      <p v-if="singlecompany.companyEmail">
                        <img
                          src="~@/assets/media/icons/globe.svg"
                          alt="email icon"
                          height="20"
                          width="20"
                        />{{ singlecompany.companyEmail }}
                      </p>
                      <p v-if="singlecompany.phone">
                        <img
                          src="~@/assets/media/icons/call.svg"
                          alt="phone icon"
                          height="20"
                          width="20"
                        />{{ singlecompany.phone }}
                      </p>
                    </div>
                    <div class="col">
                      <p v-if="singlecompany.currentlyBooked">
                        <img
                          src="~@/assets/media/icons/company.svg"
                          alt="email icon"
                          height="20"
                          width="20"
                        />{{ singlecompany.currentlyBooked }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="row align-items-end justify-content-between widget--table-row mx-0"
              >
                <div class="col px-0"><h4>Member</h4></div>
                <div class="col px-0 text-right">
                  <ActionButton
                    label="Add a member"
                    :theme="{ primary, secondary, event, danger }"
                    class="mt-0 d-inline-block w-auto"
                    @customEvent="
                      handleAddCompanyMemberClick({
                        modal: `${mainModule}-companies-add-member`,
                        name: 'add-company-member'
                      })
                    "
                  />
                </div>
              </div>
              <div class="row mx-0">
                <div class="col">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(member, i) in singlecompany.Users" :key="i">
                        <td>{{ member.firstName }} {{ member.lastName }}</td>
                        <td>
                          <a
                            :style="{ color: primary }"
                            href="javascript:void(0)"
                            @click="
                              handleViewMemberProfile({
                                modal: `${mainModule}-member-view-profile`,
                                name: 'view-member-profile',
                                member: member
                              })
                            "
                            >View member</a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </WidgetDetails>
          </div>
        </div>
      </div>
    </div>
    <Spinner v-else :theme="primary" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ActionButton from "@/components/ActionButton";
import SearchBar from "@/components/SearchBar";
import Widget from "@/modules/concierge/elements/Widget";
import WidgetDetails from "@/modules/concierge/elements/WidgetDetails";
import Spinner from "@/components/Spinner";
import axios from "@/helpers/axios";
import { socketSender } from "@/helpers/socket";
import * as logger from "@/helpers/logger";

export default {
  name: "ConciergeCompanies",
  components: {
    SearchBar,
    Widget,
    WidgetDetails,
    ActionButton,
    Spinner
  },
  data() {
    return {
      officeType: {
        label: null,
        value: null
      },
      activeTab: 0,
      loading: false,
      mainModule: this.$route.matched[0].name,
      activeIndex: 0,
      widgetOptions: [
        {
          icon: "edit",
          label: "Edit Details",
          method: "editCompanyDetails"
        },
        {
          icon: "Deactivate",
          label: "Deactivate",
          method: "deleteCompany"
        }
      ],
      tabs: [
        {
          id: 0,
          label: "Private Office",
          url: "/admin/companies/private-office",
          style: {}
        },
        {
          id: 1,
          label: "Virtual Office",
          url: "/admin/companies/virtual-office",
          style: {}
        }
      ],
      indicatorStyle: {},
      loaded: false
    };
  },
  watch: {
    $route(from) {
      this.fetchCompanies(from);
    },
    primary(val) {
      this.indicatorStyle.backgroundColor = val;
    },
    indicatorStyle() {
      this.loaded = true;
    }
  },
  computed: {
    companies() {
      return this.$store.state.concierge.companyList.data;
    },
    singlecompany() {
      return this.$store.state.concierge.companyList.data[this.activeIndex];
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  async created() {
    await this.fetchCompanies(this.$route);
    this.activeIndex = 0;
    this.initTabIndicator();
  },
  methods: {
    ...mapActions({
      changeActiveTrail: "changeActiveTrail"
    }),
    async fetchCompanies(from) {
      if (from.meta.officeType) {
        await axios
          .get(`/categories?name=${from.meta.officeType}`)
          .then(async response => {
            const { data: offices } = response.data;
            this.officeType.label = from.meta.officeType;
            if (offices.length > 0) {
              this.officeType.value = offices[0].id;
            } else {
              this.officeType.value = null;
            }
            await this.$store.dispatch("fetchCompanies", {
              officeType: this.officeType
            });
          })
          .catch(err => logger.error(err));
      } else {
        this.officeType = {
          label: null,
          value: null
        };
        await this.$store.dispatch("fetchCompanies", {});
      }
      await this.handleWidgetClick(0);
    },
    async onScroll(el, position) {
      let divScrollHeight = Math.floor(el.target.scrollHeight);
      let scrollCurrentHeight = Math.floor(
        position.scrollTop + el.target.offsetHeight
      );
      let data = this.$store.state.concierge.companyList;
      if (divScrollHeight === scrollCurrentHeight && data.meta.hasNextPage) {
        await this.$store.dispatch("fetchCompanies", data.links);
      }
    },
    handleTabClick(params) {
      const { url, style, id } = params.data;
      this.activeTab = id;
      this.styleliseTabIndicator(style);
      this.$router.push({ path: url });
    },
    styleliseTabIndicator(params) {
      const { left, width } = params;
      this.indicatorStyle = { left, width, backgroundColor: this.primary };
    },
    handleWidgetClick(index) {
      if (this.singlecompany) {
        const { matched } = this.$route;
        this.activeIndex = index;
        if (matched[2]) {
          this.changeActiveTrail([
            { name: "Home", link: matched[0].path },
            { name: "Companies", link: matched[1].path },
            {
              name: matched[2].meta.officeType,
              link: matched[2].path
            },
            { name: `${this.singlecompany.name}` }
          ]);
        } else {
          this.changeActiveTrail([
            { name: "Home", link: matched[0].path },
            { name: "Companies", link: matched[1].path },
            { name: `${this.singlecompany.name}` }
          ]);
        }
      }
    },
    handleAddCompanyMemberClick(params) {
      let { modal, name } = params;
      let singleRecord = this.singlecompany;
      this.$emit("showModal", { modal, name, singleRecord });
    },
    handleDeleteCompanyClick() {
      this.$swal({
        title: "Do you want to deactivate this company?",
        type: "warning",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showCancelButton: true
      }).then(async result => {
        if (result.value == true) {
          /**
           * SOCKET: Remove company
           */
          socketSender(
            "updateLog",
            `${this.$store.getters.getFullUser} deactivated the company named ${this.singlecompany.name}`
          );
          this.$store.dispatch("removeCompany", this.singlecompany.id);
          await this.$store.dispatch("fetchCompanies", {
            officeType: this.officeType
          });

          this.activeIndex = this.activeIndex == 0 ? 0 : this.activeIndex - 1;
        }
      });
    },
    handleEditCompanyClick() {
      let modal =
        this.mainModule == "concierge"
          ? "concierge-companies-add-company"
          : "admin-companies-page-add-company";
      let name = "edit-company";
      let singleRecord = this.singlecompany;
      this.$emit("showModal", { modal, name, singleRecord });
    },
    handleSearchCompany(searchTerm) {
      if (searchTerm != null && searchTerm != "") {
        if (this.$route.meta.officeType) {
          let catID = this.$route.meta.officeType == "Private Office" ? 3 : 4;
          searchTerm = searchTerm + "&categoryId=" + catID;
        }
        this.$store.dispatch("searchCompany", searchTerm);
        this.activeIndex = 0;
      } else {
        let officeType =
          this.officeType.value != null ? { officeType: this.officeType } : {};
        this.$store.dispatch("fetchCompanies", officeType);
      }
    },
    handleViewMemberProfile(params) {
      const { modal, name, member } = params;
      let singleRecord = this.singlecompany;
      this.$emit("showModal", { modal, name, member, singleRecord });
    },
    initTabIndicator() {
      const tabs = this.$refs.tabs;

      tabs.map((el, i) => {
        let elWidth = el.offsetWidth;
        let leftPosition = el.offsetLeft;
        this.tabs[i].style.width = `${elWidth}px`;
        this.tabs[i].style.left = `${leftPosition}px`;
        this.tabs[i].style.backgroundColor = this.primary;
      });
      this.indicatorStyle = this.tabs[0].style;
    }
  }
};
</script>

<style lang="scss" scoped>
.companies {
  padding: 0 15px;
  .content--main {
    height: calc(
      100vh - 274px
    ); /* height of viewport minus the sum of nav.header and <SearchBar/> */
    overflow-x: hidden;
    overflow-y: auto;
    padding-bottom: 20px;
    padding-top: 20px;
    & > .row {
      height: 100%;
      div[class^="col-"] {
        height: 100%;
        overflow: auto;
      }
    }
    .company {
      &--list {
        border-radius: 5px;
        overflow: auto;
        height: 100%;
      }
      &--profile {
        background-color: $gray-50;
        border-radius: 5px;
        max-height: 100%;
        overflow: auto;
        .widget--avatar {
          margin-right: 30px;
          span {
            align-items: center;
            background-color: $brand-primary;
            border-radius: 50%;
            color: $white;
            display: flex;
            font-family: "Gotham";
            font-size: $font-size-xl;
            font-weight: 500;
            height: 110px;
            justify-content: center;
            width: 110px;
          }
          img {
            border-radius: 50%;
            display: block;
            height: 110px;
            object-fit: cover;
            width: 110px;
          }
        }
        .widget--details-wrapper {
          h4 {
            color: $gray-900;
            font-size: $font-size-md;
            font-weight: 500;
            margin-bottom: 10px;
          }
          p {
            align-items: flex-start;
            display: flex;
            font-family: "Gotham Book";
            font-size: $font-size-sm;
            img {
              margin-right: 10px;
              height: 20px;
              width: 20px;
            }
            &.-muted {
              color: $gray-550;
            }
          }
        }
        .widget--table-row {
          border-bottom: 1px solid $gray-250;
          padding: 10px 0;
          h4 {
            color: $gray-900;
            font-size: $font-size-xs;
            font-weight: 500;
          }
        }
        .table {
          font-size: $font-size-xs;
          thead {
            th {
              color: $gray-900;
              font-weight: 500;
            }
          }
          tbody {
            td {
              color: $gray-900;
              font-family: "Gotham Book";
              &.member--status {
                font-family: "Gotham";
                font-weight: 600;
                letter-spacing: 1px;
              }
            }
          }
        }
      }
    }
    .length-0 {
      span {
        color: $gray-900;
        font-family: "Gotham Book";
        font-size: $font-size-sm;
        text-align: left;
      }
    }
  }
  .tabs-wrapper {
    display: flex;
    overflow: auto;
    padding: 10px 0;
    position: relative;
    .tab {
      color: $gray-500;
      cursor: pointer;
      flex-shrink: 0;
      font-family: "Gotham";
      font-weight: 500;
      font-size: $font-size-base;
      margin-right: 40px;
      position: relative;
      transition: all 0.2s ease;
      &:last-child {
        margin-right: 0;
      }
      &.active {
        color: $gray-900;
      }
      &:hover {
        color: $gray-900;
        text-decoration: none;
      }
    }
  }
  .indicator {
    bottom: 0;
    content: "";
    height: 2px;
    position: absolute;
    transition: all 0.2s ease-in-out;
    width: 100%;
  }
  .content--header {
    align-items: center;
    border-bottom: 1px solid $gray-200;
    display: flex;
    &-col {
      border-bottom: 1px solid #efefef;
      padding: 5px 0;
      position: relative;
    }
  }
}
</style>
